export const dateDiff = (date1: Date, date2: Date) => {
    const daysDiff = Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
    return daysDiff < 0 ? '' :  Math.abs(daysDiff);
}